// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerLinkListStyles } from "@awc/Overrides/Widgets/Header/HeaderLinkList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

headerLinkListStyles.link = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        color: "text.main",
        weight: fontConfig.weight.regular,
        css: css`
            margin: 0;
            text-transform: none;
        `,
    },
    css: css`
        &&& {
            ${TypographyStyle} {
                color: ${color("text.main")};
            }
            &:hover ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
            &:focus-visible ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
        }
    `,
};
headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        text-align: left;
        padding: 0;
        margin-right: 0;
        display: flex;
        column-gap: 24px;
        ${xScreen("lte", "md")} {
            column-gap: 12px;
        }
    `,
};
headerLinkListStyles.linkWrapper = {
    css: css`
        line-height: ${fontConfig.lineHeight.singleLineSmall};
        display: flex;
    `,
};
